import * as Types from '../actions';

type LoginActionParams = {
  login: string;
  password: string;
  then?: VoidFunction;
};

export function login(payload: LoginActionParams): Types.LoginRequestAction {
  return {
    type: Types.LOGIN_REQUEST,
    payload,
  };
}

export type LoginActionCreator = typeof login;

export function loginFailed(error: string): Types.LoginFailureAction {
  return { type: Types.LOGIN_FAILURE, error };
}

export function loginSuccess(payload: {
  user: any;
  session: any;
}): Types.LoginSuccessAction {
  return {
    type: Types.LOGIN_SUCCESS,
    payload,
  };
}

export function logout(then?: VoidFunction): Types.LogoutRequestAction {
  return {
    type: Types.LOGOUT_REQUEST,
    payload: { then },
  };
}

export type LogoutActionCreator = typeof logout;

export function logoutSuccess(): Types.LogoutSuccessAction {
  return { type: Types.LOGOUT_SUCCESS };
}

export type LogoutSuccessActionCreator = typeof logoutSuccess;

export function logoutFailure(error: string): Types.LogoutFailureAction {
  return { type: Types.LOGOUT_FAILURE, error };
}
